"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const react_hook_form_1 = require("react-hook-form");
const TextSchemaComponent = (props) => {
    var _a;
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const { onBlur } = registerProps, otherRegisterProps = __rest(registerProps, ["onBlur"]);
    const formContext = (0, react_hook_form_1.useFormContext)();
    const handleOnBlur = () => {
        var _a, _b;
        onBlur();
        fieldState.isDirty && ((_b = (_a = props.schema).autoSaveHandler) === null || _b === void 0 ? void 0 : _b.call(_a));
        if (props.schema.trim) {
            const trimmedValue = value === null || value === void 0 ? void 0 : value.trim();
            if (trimmedValue !== value) {
                formContext.setValue(props.fieldPath, trimmedValue, {
                    shouldValidate: true,
                    shouldDirty: true,
                });
            }
        }
    };
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState, loading: props.schema.showSpinner &&
            fieldState.isDirty &&
            ((_a = formContext === null || formContext === void 0 ? void 0 : formContext.formState) === null || _a === void 0 ? void 0 : _a.isSubmitting) },
        react_1.default.createElement(Form_1.default.Control, Object.assign({ type: "text", className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), value: value || "", onBlur: handleOnBlur }, otherRegisterProps))));
};
TextSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("TextDisplayComponent", (value, schema) => {
    if (schema.view === "form") {
        schema.schemaType;
        return react_1.default.createElement("span", { className: "readonly-field" }, value);
    }
    return value;
});
exports.default = TextSchemaComponent;
